/* eslint-disable */
<template>
	<div class="amd-carmarket cm-carmarket cm-main cm-body">
		<page-header>
			<template v-slot:page-header>
				<div class="row gx-3">
					<div class="col-auto" v-if="this.$route.name === 'Details'">
						<router-link
							:to="{ name: 'List' }"
							class="btn btn-sm btn-outline-white"
						>
							<i class="bi bi-arrow-left"></i> Zurück
						</router-link>
					</div>
					<div class="col">
						<h1
							class="d-inline-block"
							:class="{ 'no-uppercase': this.$route.name === 'Details' }"
						>
							{{ this.$store.state.pageTitle }}
						</h1>
					</div>
				</div>
			</template>
		</page-header>
		<router-view v-slot="{ Component, route }">
			<transition :name="route.meta.transition">
				<component
					:is="Component"
					:list="list"
					:filter="filter"
					:loading="loading"
					:first-init="firstInit"
					:ref-data="refData"
					@get-all-items="getAllItems()"
					@get-list-items="getListItems()"
				/>
			</transition>
		</router-view>
	</div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import store from '@/store'
import DarmasApiService from '@/services/DarmasApiService'

export default {
	components: {
		PageHeader,
	},
	data() {
		return {
			pageTitle: 'FAHRZEUGMARKT',
			loading: true,
			search: {},
			filter: {
				init: false,
				loading: true,
				fields: {},
				items: {},
			},
			list: {
				sort: {
					adProperty: 'images',
					sortOrder: 1,
				},
				init: false,
				loading: true,
				countTotal: 1,
				page: 1,
				perPage: 20,
				items: [],
			},
			car: {},
			refData: {},
			screenSize: {},
		}
	},
	computed: {
		firstInit() {
			return this.list.init && this.filter.init
		},
	},
	methods: {
		getAllItems() {
			this.list.loading = true
			this.filter.loading = true
			// Load List Data
			DarmasApiService.getListItems()
				.then((response) => {
					if (response.data) {
						// Load List Items
						this.list.countTotal = response.data.countTotal
						this.list.page = store.state.pageNum
						this.list.items = response.data.items
						const title = 'Fahrzeugmarkt | Seite ' + store.state.pageNum
						DarmasApiService.setMetaData(title)
					} else {
						this.list.countTotal = 0
					}
					this.list.loading = false
				})
				.catch((error) => {
					console.log(error)
				})

			let filterUrl = DarmasApiService.decodeFiltersFromStateToUrl()
			if (filterUrl.length > 3 || DarmasApiService.filtersActive()) {
				let pushUrl = '?' + filterUrl.slice(1)
				window.history.pushState('', '', pushUrl)
			} else {
				window.history.pushState('', '', '')
			}

			// Load Filter Data
			DarmasApiService.getFilterFields()
				.then((response) => {
					this.filter.fields = response.data.filterFields

					this.filter.loading = false
					this.loading = false
				})
				.catch((error) => {
					console.log(error)
				})
		},
		getListItems() {
			this.list.loading = true
			let filterUrl = DarmasApiService.decodeFiltersFromStateToUrl()
			if (filterUrl.length > 3 || DarmasApiService.filtersActive()) {
				let pushUrl = '?' + filterUrl.slice(1)
				window.history.pushState('', '', pushUrl)
			} else {
				window.history.pushState('', '', '')
			}
			DarmasApiService.getListItems().then((response) => {
				if (response.data) {
					// Load List Items
					this.list.countTotal = response.data.countTotal
					this.list.page = store.state.pageNum
					this.list.items = response.data.items
					const title = 'Fahrzeugmarkt | Seite ' + store.state.pageNum
					DarmasApiService.setMetaData(title)
				} else {
					this.list.countTotal = 0
				}

				this.list.loading = false
			})
		},
	},
	created() {
		// BOOTSTRAP HELPER

		const windowWith = window.screen.width

		if (windowWith < 576) {
			console.log(windowWith + 'px | Extra small - xs (max 576px)')
		} else if (windowWith >= 576 && windowWith < 768) {
			console.log(windowWith + 'px | Small - sm (576px - 768px)')
		} else if (windowWith >= 768 && windowWith < 992) {
			console.log(windowWith + 'px | Medium - md (786px - 992px)')
		} else if (windowWith >= 992 && windowWith < 1200) {
			console.log(windowWith + 'px | Large - lg (786px - 992px)')
		} else if (windowWith >= 1200 && windowWith < 1400) {
			console.log(windowWith + 'px | Xtra Large - xl (1200px - 1400px)')
		} else if (windowWith >= 1400) {
			console.log(windowWith + 'px | Xtra Xtra large - xxl (min 1400px)')
		}

		if (!this.firstInit) {
			// Load Bookmarks from Localstorage
			if (
				window.localStorage.getItem('bookmarkedCars') !== undefined ||
				window.localStorage.getItem('bookmarkedSearch') !== undefined
			) {
				const bookmarkedCars = window.localStorage.getItem('bookmarkedCars')
				const bookmarkedSearch = window.localStorage.getItem('bookmarkedSearch')
				store.commit(
					'loadBookmarksFromLocalStoreage',
					bookmarkedCars,
					bookmarkedSearch
				)
			}

			// Load TradeIn from Localstorage

			/*			if (window.localStorage.getItem('tradeIn') !== undefined) {
				const tradeIn = window.localStorage.getItem('tradeIn')
				store.state.user.tradeIn = JSON.parse(tradeIn)
			}*/

			// Load URL Parameters
			DarmasApiService.getRefData()
				.then((response) => {
					this.refData = response.data
					if (window.location.search !== '') {
						return DarmasApiService.getFiltersFromUrl()
					}
					return false
				})
				.then((response) => {
					if (response.data) {
						console.log('URL DATA', response.data)
						store.commit('setFilterFromUrl', response.data)
						this.list.page = store.state.pageNum
					}

					// Load List Data
					DarmasApiService.getListItems()
						.then((response) => {
							// Load List Items
							this.list.items = response.data.items
							this.list.countTotal = response.data.countTotal
							this.list.init = true
							this.list.loading = false
						})
						.catch((error) => {
							console.log(error)
						})

					DarmasApiService.getFilterFields()
						.then((response) => {
							this.filter.fields = response.data.filterFields
							this.filter.loading = false
							this.filter.init = true
							this.loading = false
							const title = 'Fahrzeugmarkt | Seite ' + store.state.pageNum
							DarmasApiService.setMetaData(title)
						})
						.catch((error) => {
							console.log(error)
						})
				})
				.catch((error) => {
					console.log(error)
				})
		}

		// watch the params of the route to fetch the data again
	},
}
</script>
<style lang="scss">
@import '@/assets/scss/carmarket.scss';
@import '@vueform/slider/themes/default.scss';

// Animation Fliplist

.slide-left-enter-active,
.slide-left-leave-active {
	transition: all 0.3s;
}

.slide-left-enter-from {
	transform: translateX(-40px);
	opacity: 0;
}

.slide-left-leave-to {
	transform: translateX(40px);
	opacity: 0;
}

// Animation Fliplist

.slide-right-enter-active,
.slide-right-leave-active {
	transition: all 0.3s;
}

.slide-right-enter-from {
	transform: translateX(40px);
	opacity: 0;
}

.slide-right-leave-to {
	transform: translateX(-40px);
	opacity: 0;
}
</style>
